export const NONE = 1;
export const DECREASE = 2;
export const INCREASE = 3;
export const BOTH = 4;



// WEBPACK FOOTER //
// ./js/constants/AcceptFactorChange.js